<template>
  <div>
    <van-nav-bar
      title="提现"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    
    <van-form @submit="getAccountbank">
      <van-row>
        <van-col class="textStyle" span="16">
          <span style="color:red;">请选择提现方式</span> 
        </van-col>
      </van-row>
       <van-row class="rowStyle">
        <van-col span="16">
          <van-radio-group v-model="radio">
        <van-cell-group>
          <van-row
            v-for="(item, index) in withdrawTypes"
            :key="index"
            clickable
            @click="changeInstructions(index, item.type)"
            style="margin-left: 16px; font-size: 14px"
          >
            <van-col span="4">
              <p style="text-align: center; margin: 2px">
                <img style="height: 25px" src="../assets/images/recharge.jpg" />
              </p>
            </van-col>
            <van-col span="16">
              <p style="margin: 2px">{{ item.name }}</p>
            </van-col>
            <van-col span="4">
              <p style="margin: 2px"><van-radio :name="index" /></p>
            </van-col>
          </van-row>
        </van-cell-group>
      </van-radio-group>
        </van-col>
       </van-row>

       <div v-if="withdrawTypeNo == 1">
         <van-row>
            <van-col class="textStyle" span="18">
             <span style="color:red;">提现钱包地址</span> 
            </van-col>
            <van-col class="textStyle" span="6">
             <span @click="openDigitalCurrency" style="align:right;color:#0000ffab;">钱包管理</span> 
            </van-col>
        </van-row>
        <van-row>
            <van-col class="textStyle" span="6">
             <span>平台币种 :</span> 
            </van-col>
            <van-col class="textStyle" span="8">
             <span style="align:left;">{{withdrawTypeName}}</span> 
            </van-col>
        </van-row>
        <van-row>
            <van-col class="textStyle" span="6">
             <span>钱包地址 :</span> 
            </van-col>
            <van-col class="textStyle" span="8">
             <span style="align:left;">{{walletAddress}}</span> 
            </van-col>
        </van-row>
       </div>

      <div v-if="withdrawTypeNo == 0">
         <van-row>
            <van-col class="textStyle" span="18">
             <!-- <span style="color:red;">请务必用本人（{{ bankList.account }}）的银行卡提款！</span>  -->
             <span style="color:red;">提现银行卡</span> 
            </van-col>
            <van-col class="textStyle" span="6">
             <span @click="openBank" style="align:right;color:#3889fa;">银行卡管理</span> 
            </van-col>
        </van-row>
        <van-row>
            <van-col class="textStyle" span="6">
             <span>银行名称 :</span> 
            </van-col>
            <van-col class="textStyle" span="8">
             <span style="align:left;">{{bankList.name}}</span> 
            </van-col>
        </van-row>
        <van-row>
            <van-col class="textStyle" span="6">
             <span>   开户支行 :</span> 
            </van-col>
            <van-col class="textStyle" span="18">
             <span style="align:left;">{{bankList.address}}</span> 
            </van-col>
        </van-row>
        <van-row>
            <van-col class="textStyle" span="6">
             <span>   银行卡号 :</span> 
            </van-col>
            <van-col class="textStyle" span="18">
             <span style="align:left;">{{bankList.card}}</span> 
            </van-col>
        </van-row>
        <van-row>
            <van-col class="textStyle" span="6">
             <span>   开户姓名 :</span> 
            </van-col>
            <van-col class="textStyle" span="8">
             <span style="align:left;">{{bankList.account}}</span> 
            </van-col>
        </van-row>
       </div>
      <van-row style="padding: 10px 0px;">
        <van-col class="textStyle" span="16">
          <span style="color:red;">请提现</span> 
        </van-col>
      </van-row>
      <van-row>
        <van-col span="16">
          <van-field
            v-model="money"
            type="digit"
            label="提现金额"
            placeholder="请输入提现金额"
            input-align="left"
            autocomplete="off"
          />
        </van-col>
      </van-row>
      <van-row>
        <van-col span="24">
          <van-field
        v-if="withdrawTypeNo==2"
        v-model="gxpay_id"
        type="digit"
        label="Gxpay ID"
        placeholder="请输入Gxpay ID"
        input-align="right"
        style="color: #000000"
      >
      <template #button>
        <van-checkbox v-model="confirmChecked">已核对确认</van-checkbox>
      </template>
      </van-field>
      </van-col>
      </van-row>
      <van-row>
        <van-col span="16">
          <van-field
            v-model="password"
            type="password"
            label="提现密码"
            placeholder="请输入提现密码"
            input-align="left"
          />
        </van-col>
      </van-row>
      <van-row v-for="(item, index) in auto_fill_amounts" :key="index">
             <van-col span="6" v-for="(item1, index1) in item" :key="index1">
               <van-button round plain hairline native-type="button" type="danger" size="normal" @click="handleAmount(item1)" style="margin-left: 15%; margin-top: 5px;">{{ item1 }}元</van-button>
             </van-col>
           </van-row>
      <van-row class="rowStyle">
        <van-col span="5" style="line-height: 30px"
          ><span>佣金金额</span></van-col
        >
        <van-col span="11" style="text-align: left; line-height: 30px"
          ><p style="margin: 0px">
            <span>{{ cash }}元</span>
          </p>
        </van-col>
        <van-col span="8" style="text-align: right; line-height: 30px"
          ><p style="margin: 0px">
            <router-link to="information/withdrawal_pass"><span style="color:#3889fa;align:right;">修改提现密码</span></router-link>
          </p>
        </van-col>
      </van-row>
     
    <div style="margin:0px 12px 0px 12px;">  
     <van-button style="height: 30px;" size="normal" type="danger" block>提现 {{ button_text }}</van-button>
    </div>
    </van-form>
  </div>
</template>

<script>
import { version } from "../../package";

    export default {
      name: "Withdrawal",
      data(){
        return{
          bankList:{
            name:'',
            card:'',
            address:'',
            account:'',
          },
          radio: '0',
          cash:'0.00',
          money:'',
          password:'',
          bankWithdrawDetails:false,
          digitalCurrencyWithdrawDetails:false,
          bankCardList:[],
          withdrawalData:{
            name:'',
            card:'',
            address:'',
            account:'',
          },
          selectedTypeId: "",
          withdrawTypes:[],
          withdrawTypeNo:'',
          walletAddress:'',
          withdrawTypeName:'',
          auto_fill_amounts: [],
          radio:1,
          data: "",
          gxpay_id:'',
          confirmChecked:false,
          button_text: null,
          notice_1_1: "",
      notice_2_1: "",
      notice_2_2: "",
        }
      },
      methods:{
        openBank(){
          let that = this;
          //if (that.bankStatus){
            that.$router.push('information/bind_bank');
          //}
        },
        openDigitalCurrency(){
          let that = this;
          console.log("WWWQQQQWW")
          //if (that.digitalCurrencyStatus){
            that.$router.push('information/digital_currency_wallet');
         // }
        },
        getUser() {
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "user",
                token: sessionStorage.getItem("token")
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code === 1) {
                that.cash = resData.data.cash;
              } else if (res.data.code === 0 || res.data.code === -1) {
                that.$toast.fail(resData.msg);
              }
            });
        },
        //查询提现是否有银行卡
        getAccountbank(){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "accountbank",
              token: sessionStorage.getItem("token")
            }
          })
            .then(function(res) {
              let resData = res.data;
              if (res.data.code == 1) {
                if (resData.data.length === 0){
                  that.$toast({
                    type:'fail',
                    message:'还未绑定银行卡,请前去绑定银行卡才可提现',
                    onClose:function () {
                      that.$router.push('/member/information');
                    }
                  });
                }else{
                  that.Withdrawal(resData)
                }

              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            });
        },

        //提现
        Withdrawal(bankCard) {
          let that = this;
          let bankCardList = bankCard.data;
          let card = bankCardList[0].card;
          let name = bankCardList[0].name;
          let withdrawTypeNo = that.withdrawTypeNo;
          let digitalWalletAddress = that.walletAddress;
          console.log(digitalWalletAddress);
          let withdraw = that.withdrawTypes[that.radio];
          digitalWalletAddress = withdrawTypeNo == 1 ? that.walletAddress : '';
          if (that.money == "") {
        that.$toast.fail("请输入提现金额");
        return false;
      } else if (that.password == "") {
        that.$toast.fail("请输入提现密码");
        return false;
      } else if (withdraw.type == 2 && (that.gxpay_id=="" || that.gxpay_id==undefined)) {
        that.$toast.fail("请输入您的GXPay ID");
        return false;  
      } else if(withdraw.type == 2 && that.confirmChecked == false){
        that.$toast.fail("请核对您的Gxpay ID 后再确认提现操作");
        return false;
      } else {
        switch (withdraw.type) {
         
         case 2:
         that
         .$http({
           url: "/",
           method: "post",
           data: {
             nozzle: "withdraw",
             token: sessionStorage.getItem("token"),
             number: that.money,
             password: that.password,
             id:withdraw.id,
             type:withdraw.type,
             gxpay_id:that.gxpay_id
           },
         })
         .then(function(res) {
              if (res.data.code == 1) {
                that.$toast.success({
                  message: '提现成功',
                  type: 'success',
                  onClose:function () {
                    that.$router.push('/member/members')
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            })
         .catch(() => {
           that.$toast.fail(that.$NoNetworkErrorMsg);
         });

         break;
         case 1:
         that
         .$http({
           url: "/",
           method: "post",
           data: {
             nozzle: "withdraw",
             token: sessionStorage.getItem("token"),
             number: that.money,
             password: that.password,
             id:withdraw.id,
             type:withdraw.type,
             wallet_address: digitalWalletAddress,

           },
         })
         .then(function(res) {
              if (res.data.code == 1) {
                that.$toast.success({
                  message: '提现成功',
                  type: 'success',
                  onClose:function () {
                    that.$router.push('/member/members')
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            })
         .catch(() => {
           that.$toast.fail(that.$NoNetworkErrorMsg);
         });

         break;
         default:
       that
         .$http({
           url: "/",
           method: "post",
           data: {
             nozzle: "withdraw",
             token: sessionStorage.getItem("token"),
             number: that.money,
             password: that.password,
             name: that.name,
             card: that.card,
             id:withdraw.id,
             type:withdraw.type,

           },
         })
         .then(function(res) {
              if (res.data.code == 1) {
                that.$toast.success({
                  message: '提现成功',
                  type: 'success',
                  onClose:function () {
                    that.$router.push('/member/members')
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            })
         .catch(() => {
           that.$toast.fail(that.$NoNetworkErrorMsg);
         });
         break;
     }
    }
        },
        cardDetails(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "accountbank",
                token: sessionStorage.getItem("token"),
              }
            })
            .then(function(res) {
              let resData = res.data;
              if (resData.code == 1) {
                that.bankCardList = res.data.data;
                that.withdrawalData.account = that.bankCardList[0].account;
                that.withdrawalData.card = that.bankCardList[0].card;
                that.withdrawalData.name = that.bankCardList[0].name;
                that.withdrawalData.address = that.bankCardList[0].address;
              } else if (resData.code == 0 || resData.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            });
        },
        getDigitalInfo(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "digital_info",
                token: sessionStorage.getItem("token"),
              }
            })
            .then(function(res) {
              let resData = res.data;
              if (resData.code == 1) {
                that.walletAddress = resData.data.wallet_address;
                console.log(that.walletAddress);
              } else if (resData.code == 0 || resData.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            });
        },
        getWithdrawTypes(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "account_withbank",
                token: sessionStorage.getItem("token"),
                app_version: version,

              }
            })
            .then(function(res) {
              let resData = res.data;
              if (resData.code == 1) {
            let withdrawType = resData.data.types;
            for (let i = 0, len = withdrawType.length; i < len; i++) {
              if (withdrawType[i].isdefault == 1) {
                that.radio = i;
              }
            }
            that.withdrawTypes = withdrawType;
            let SelectedType = withdrawType[that.radio];
            that.notice_1_1 = SelectedType.notice_1_1;
            that.notice_2_1 = SelectedType.notice_2_1;
            that.notice_2_2 = SelectedType.notice_2_2;
            that.auto_fill_amounts = SelectedType.auto_fill_amounts;
            that.button_text = SelectedType.button_text;
            that.selectedTypeId = SelectedType.id;
            that.withdrawTypeNo=SelectedType.type;              
             that.withdrawTypeName = SelectedType.name;
              } else if (resData.code == 0 || resData.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            });
        },
        handleAmount(amount){
      let that = this;
      that.money = amount;
    },
        getGxpayId(){
      let that = this;
      that
      .$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "gxpay_thirdparty_digital_currency",
          token: sessionStorage.getItem("token")
        }
      })
      .then(function(res) {
        if (res.data.code == 1) {
          let resData = res.data;
          if(resData.data.user == true){
            that.gxpay_id = resData.data.numberId;
          }else{
            if(that.withdrawTypeNo==2){
              window.open(resData.data.homeUrl,"_blank");
            that.$router.push("/member/members"); 
            }
            


          }
        }
      });
    },
    changeInstructions(index, type) {
      let that = this;
      that.radio = index;
      let SelectedType = that.withdrawTypes[index];
      that.selectedTypeId = SelectedType.id;
      that.notice_1_1 = SelectedType.notice_1_1;
      that.notice_2_1 = SelectedType.notice_2_1;
      that.notice_2_2 = SelectedType.notice_2_2;
      that.auto_fill_amounts = SelectedType.auto_fill_amounts;
      that.withdrawTypeNo=SelectedType.type;
      that.withdrawTypeName = SelectedType.name;
      that.button_text = SelectedType.button_text;
      that.money = '';
      that.confirmChecked = false;
      that.getGxpayId();
    },
        getBankList(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "bank_info",
                token: sessionStorage.getItem("token")
              }
            })
            .then(function(res) {
              if (res.data.code == 1) {
                that.bankList = res.data.data.bank;
                that.bankList.name = res.data.data.name;
                that.bankList.account = res.data.data.account;
                that.bankList.address = res.data.data.address;
                that.bankList.card = res.data.data.card;
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            });
        }
      },
      mounted:function () {
        this.getUser();
        this.cardDetails();
        this.getWithdrawTypes();
        this.getDigitalInfo();
        this.getBankList();
        this.getGxpayId();

      }
    }
</script>

<style scoped>
.rowStyle {
  padding: 10px 16px;
  border-bottom: 1px solid #ebedf0;
  font-size: 14px;
}
.textStyle {
  padding-left: 15px;
  padding-top: 15px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Withdrawal.vue